import Logger from '../Logger';
import PublicEvent from './PublicEvent';

class StopRtmpEvent extends PublicEvent {
  handle(msg) {
    this.context._api
      .stopBroadcast('generic')
      .then(() => super.handle({ type: msg.type }))
      .catch(error => Logger.warn(error));
  }
}

export default StopRtmpEvent;
